import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import axios from "axios";
import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import AuditSection from "@/pages/AuditSection";
import Report from "@/pages/Report";
import SavedAudits from "@/pages/SavedAudits";
import AdminPanel from "@/pages/AdminPanel";
import Presentation from "@/pages/Presentation";
import SharedPresentation from "@/pages/SharedPresentation";

// Note: Using Authorization header (Bearer token) instead of cookies
// This avoids CORS issues with the proxy layer overriding Access-Control-Allow-Origin

// CRITICAL: Detect session_id synchronously during render (not in useEffect)
// This prevents race conditions where AuthProvider's checkAuth runs before session exchange
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment for session_id - synchronous check during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/dashboard/:auditId" element={<Dashboard />} />
      <Route path="/audit/:auditId/:sectionId" element={<AuditSection />} />
      <Route path="/report/:auditId" element={<Report />} />
      <Route path="/audits" element={<SavedAudits />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/presentation/:auditId" element={<Presentation />} />
      <Route path="/shared/:shareToken" element={<SharedPresentation />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-zinc-950">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#18181B',
              border: '1px solid #27272A',
              color: '#FAFAFA',
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
